import type { ServiceUrlBases } from './types'

export const makeIsInternalDomain =
  (internalDomains: string[]) =>
  (url: string): boolean =>
    internalDomains.some((domain) => url.includes(domain))

type ServiceName = string
type ServiceUrl = string

/*
 *  A utility function to create a mapping object to use a "serviceName"
 *  instead of providing the "baseURL"
 *
 *  @param serviceUrls - a mapping object with key as 'serviceName' and value as a 'service url'
 *  @param internalDomains - list of internal urls
 * */
export const getServiceUrlBases = <T extends Record<ServiceName, ServiceUrl>>(
  serviceUrls: T,
  internalDomains = Object.values(serviceUrls)
): ServiceUrlBases => {
  const isInternalDomain = makeIsInternalDomain(internalDomains)

  return Object.keys(serviceUrls).reduce(
    (serviceUrlBasesAcc, serviceName) => ({
      ...serviceUrlBasesAcc,
      [serviceName]: {
        url: serviceUrls[serviceName],
        isInternal: isInternalDomain(serviceUrls[serviceName]),
      },
    }),
    {}
  )
}
